<template>
  <div class="my-2 flex sm:flex-row flex-col">
    <div class="w-full md:w-2/5 flex justify-center items-center">
      <div class="w-2/3">
        <div class="relative">
          <select
            class="appearance-none h-full rounded-r sm:rounded-r-none block w-full bg-white border border-gray-400 text-gray-700 text-sm py-3 px-4 pr-16 leading-tight focus:outline-none focus:border-l focus:border-r focus:bg-white focus:border-gray-500"
          >
            <option value="" disabled selected>Change Role</option>
            <option value="admin">Admin</option>
            <option value="staff">Staff</option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="text-gray-500 h-3 w-3"
              viewBox="0 0 512 512"
              fill="#6A7E8A"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m400 216a23.928 23.928 0 0 1 -16.971-7.029l-127.029-127.03-127.029 127.03a24 24 0 0 1 -33.942-33.942l144-144a24 24 0 0 1 33.942 0l144 144a24 24 0 0 1 -16.971 40.971zm-127.029 264.971 144-144a24 24 0 0 0 -33.942-33.942l-127.029 127.03-127.029-127.03a24 24 0 0 0 -33.942 33.942l144 144a24 24 0 0 0 33.942 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="w-1/3">
        <button class="btn md:inline-block bg-primary px-4 md:px-10 md:mx-5">
          Change
        </button>
      </div>
    </div>
    <div
      class="w-full md:w-2/5 flex flex-col md:flex-row items-center md:ml-20 lg:ml-8 mt-2"
    >
      <div class="block relative">
        <input
          placeholder="Enter staff name here"
          class="appearance-none rounded-sm sm:rounded-l-none border border-gray-400 border-b block pr-32 pl-4 py-2 pt-3 w-full bg-white text-sm placeholder-gray-400 text-gray-700 focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none"
        />
        <span class="h-full absolute inset-y-0 right-0 flex items-center pr-2">
          <svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500">
            <path
              d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z"
            ></path>
          </svg>
        </span>
      </div>
    </div>

    <div class="w-full md:w-1/5 flex items-center mt-2">
      <div class="ml-auto">
        <p class="mr-1">
          <small
            contenteditable
            class="px-2 rounded border border-gray-400 mr-1 py-1 font-medium"
            >1</small
          >
          <small class="font-medium">of 2</small>
        </p>
      </div>
      <div
        class="h-5 w-5 mr-1 flex justify-center items-center rounded-full bg-primary cursor-pointer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          fill="none"
          viewBox="0 0 24 24"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-chevron-left w-4 h-4"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </div>
      <div
        class="h-5 w-5 ml-1 flex justify-center items-center rounded-full bg-primary cursor-pointer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-chevron-right w- h-4"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmployeeFilter"
};
</script>
